const { isAuthorized } = require('@smarttransit/common')

function agentStaffCanRetrievePassengerVerification (user) {
  return isAuthorized(user, 'admin')
}

function anyUserCanRetrievePassengerVerification ({ isSuperAgent, users }) {
  if (isSuperAgent) {
    return true
  }
  const list = users || []
  for (let i = 0; i < list.length; i++) {
    if (agentStaffCanRetrievePassengerVerification(list[i])) {
      return true
    }
  }
  return false
}

module.exports = {
  agentStaffCanRetrievePassengerVerification,
  anyUserCanRetrievePassengerVerification
}
